import {
  StyledContainerColumnLeft,
  StyledContainerColumnRight,
  StyledContainerRowBetween,
} from '../../../styles/ContainerStyles'
import ScheduleDialogDescriptionBlock from '../../Schedule/ScheduleDialogDescriptionBlock'
import { Box, Select, SelectChangeEvent, ToggleButtonGroup, Typography } from '@mui/material'
import MenuItem from '@mui/material/MenuItem'
import ScheduleDialogDaysSelector from '../../Schedule/ScheduleDialogDaysSelector'
import { Dispatch, SetStateAction } from 'react'
import { t } from 'i18next'
import { weekDays } from '../../../store/types/enums/WeekDay'
import { getFlexDirection, getGap } from '../../../styles/stylePropsFunctions'

type RepeatProps = {
  isSmallScreen: boolean
  repeatOption: string
  setRepeatOption: Dispatch<SetStateAction<string>>
  selectOptions: string[]
  setSelectedDaysOptions: Dispatch<SetStateAction<number[]>>
}

const RepeatSection = ({
  isSmallScreen,
  repeatOption,
  setRepeatOption,
  selectOptions,
  setSelectedDaysOptions,
}: RepeatProps) => {

  const handleRepeatOptionChange = (e: SelectChangeEvent) => {
    if (e.target.name === 'repeatOptionSelect') {
      setRepeatOption(e.target.value)
    }
  }

  return (
    <StyledContainerRowBetween
      sx={{
        gap: getGap(isSmallScreen),
        alignItems: 'flex-start',
        flexDirection: getFlexDirection(isSmallScreen),
      }}
    >
      <StyledContainerColumnLeft>
        <ScheduleDialogDescriptionBlock
          title={t('page.schedule.fillOutManyPopup.repeatTitle')}
          description={t('page.schedule.fillOutManyPopup.repeatDescription')}
        />
      </StyledContainerColumnLeft>
      <StyledContainerColumnRight>
        <Select
          size="small"
          fullWidth={true}
          defaultValue={selectOptions[0]}
          value={repeatOption}
          onChange={handleRepeatOptionChange}
          name="repeatOptionSelect"
          sx={{ mb: 2, svg: { color: 'text.mediumEmphasis' } }}
        >
          {selectOptions.map(option => (
            <MenuItem key={option} value={option}>
              {t('components.repeatselect.' + option)}
            </MenuItem>
          ))}
        </Select>
        <StyledContainerColumnRight
          sx={{
            display: 'invisible',
          }}
        >
          {repeatOption === 'Selected' ? (
            <>
              <Typography>{t('page.schedule.repeatOn')}</Typography>
              <ToggleButtonGroup
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  mt: 0.5,
                }}
              >
                {weekDays.map((day) => {
                  return (
                    <ScheduleDialogDaysSelector
                      key={day}
                      dayIndicator={day}
                      repeatOption={repeatOption}
                      setSelectedDaysOptions={setSelectedDaysOptions}
                    />
                  )
                })}
              </ToggleButtonGroup>
            </>
          ) : (
            <Box />
          )}
        </StyledContainerColumnRight>
      </StyledContainerColumnRight>
    </StyledContainerRowBetween>
  )
}

export default RepeatSection
